import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalPagoComponent } from './modal-pago.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ModalPagoComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
  ],
  // DEPRECATED ON ANGULAR V9
  // entryComponents: [ModalPagoComponent],
  // providers: [
  //   {
  //     provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
  //     useValue: { appearance: 'outline', subscriptSizing: 'dynamic' }
  //   }
  // ]
})
export class ModalPagoModule { }
